<template>
  <div class="tablaComisiones">
    <button @click.once="modalVacaciones"><i class="fa fa-plus-square"></i> Agregar vacaciones</button>
    <br>
    <table class="table table-bordered" id="comision">
      <thead class="thead-light">
      <tr>
        <th>{{data.vendedor.nombre}}</th>
        <th>Neto</th>
        <th>Comisión</th>
        <th>Devolución</th>
        <th>Comisión (Devolución)</th>
        <th>Total</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Baterias</td>
        <td>{{data.data.neto.baterias | currency }}</td>
        <td>{{data.data.comisiones.baterias | currency}}</td>
        <td>{{data.data.devolucion_neto.baterias | currency}}</td>
        <td>{{data.data.comision_devolucion.baterias || 0 | currency}}</td>
        <td>{{data.data.comisiones.baterias - data.data.comision_devolucion.baterias | currency}}</td>
      </tr>
      <tr>
        <td>General</td>
        <td>{{data.data.neto.general | currency}}</td>
        <td>{{data.data.comisiones.general | currency}}</td>
        <td>{{data.data.devolucion_neto.general | currency}}</td>
        <td>{{data.data.comision_devolucion.general | currency}}</td>
        <td>{{data.data.comisiones.general - data.data.comision_devolucion.general | currency}}</td>
      </tr>
      <tr>
        <td>Inmovilizado</td>
        <td>{{data.data.neto.inmovilizado | currency}}</td>
        <td>{{data.data.comisiones.inmovilizado | currency}}</td>
        <td>{{data.data.devolucion_neto.inmovilizado | currency}}</td>
        <td>{{data.data.comision_devolucion.inmovilizado | currency}}</td>
        <td>{{data.data.comisiones.inmovilizado - data.data.comision_devolucion.inmovilizado | currency}}</td>
      </tr>
      <tr v-if="data.data.dias.vacaciones > 0">
        <td>Vacaciones</td>
        <td>{{data.data.dias.vacaciones}} días</td>
        <td>{{data.data.comisiones.vacaciones | currency}}</td>
        <td colspan="2"></td>
        <td>{{data.data.comisiones.vacaciones | currency}}</td>
      </tr>
      <tr v-if="data.vendedor.tipo_comision === 'A'">
        <td>Semana Corrida</td>
        <td colspan="4"></td>
        <td>{{calcularSemanaCorrida() | currency}}</td>
      </tr>
      <tr>
        <td colspan="5" align="right">Total:</td>
        <td>{{(totalComision() + calcularSemanaCorrida(data.vendedor.tipo_comision || 'A'))| currency}}</td>
      </tr>
      </tbody>
    </table>
    <vuestic-modal ref="modal">
      <h4 slot="header">Agregar Vacaciones a {{data.vendedor.nombre}}</h4>
      <form @submit.prevent="agregarVacaciones">
        <div class="input-group">
          <input-comp placeholder="Días de vacaciones" label="Vacaciones" v-model="dias"/>
        </div>

        <div class="row">
          <button class="btn btn-danger btn-sm">Agregar</button>
        </div>
      </form>
    </vuestic-modal>
  </div>

</template>

<script>
  import VuesticModal from "vuestic-components/vuestic-modal/VuesticModal";
  import InputComp from "components/Componentes_Globales/Input/inputComp";
  export default {
    name: "tablaComisiones",
    components: {InputComp, VuesticModal},
    props: ["data"],
    data() {
      return {
        dias: ""
      }
    },
    methods: {
      calcularSemanaCorrida(tipo) {
        if (tipo === 'B')
          return 0
        const total = this.totalComision()
        return (total / 24) * 4
      },
      totalComision() {
        const {data} = this.data
        console.log(data)
        const inmovilizado = data.comisiones.inmovilizado - data.comision_devolucion.inmovilizado
        const general = data.comisiones.general - data.comision_devolucion.general
        const baterias = data.comisiones.baterias - data.comision_devolucion.baterias
        const vacaciones = parseInt(data.comisiones.vacaciones)
        return inmovilizado + general + baterias + vacaciones
      },
      modalVacaciones() {
        this.$refs.modal.open()
      },
      async agregarVacaciones() {
        try {
          await this.$axios.post('finanzas/comisiones/vacaciones',{
            dias: this.dias,
            vendedorId: this.data.vendedor.id,
            vendedorNombre: this.data.vendedor.nombre,
            periodoId: this.data.data.periodo
          })
          this.$swal('Éxito', 'Los días de vacaciones esta en proceso de calculo.<br>Puede que tome unos minutos en aparecer.', 'success')
        } catch(e) {
          this.$swal('Error', 'Error al agregar vacaciones', 'error')
          console.error('error al guardar')
        }
      }
    }
  }
</script>

<style scoped>

</style>
